
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import {ItemArrayManagerTableHeader} from "@/interface/TableHeader";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import TasinirBilgisiForm from "@/components/forms/TasinirBilgisiForm.vue";
import TasinmazBilgisiForm from "@/components/forms/TasinmazBilgisiForm.vue";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {SozlesmeTuru} from "@/enum/SozlesmeTuru";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import IpotekAkitTablosuAlacakFormWizard
  from "@/components/forms/form-wizard/alacak/IpotekAkitTablosuAlacakFormWizard.vue";
import {TakipTipi} from "@/enum/TakipTipi";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {HesapSekli} from "@/enum/HesapSekli";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import YevmiyeNumarasi from "@/components/inputs/YevmiyeNumarasi.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";

@Component({
  components: {
    FormDialog, DeleteDialog,
    YevmiyeNumarasi,
    ProtestoIhtarForm,
    DovizTakipSekliPicker,
    Kur,
    IpotekAkitTablosuAlacakFormWizard,
    ParaBirimiPicker,
    TasinirBilgisiForm,
    TasinmazBilgisiForm,
    IlamBilgileriForm,
    ItemArrayManager,
    Dates,
    Tutar,
    AsilAlacakKalemiForm,
    AyEkleForm,
  },
})
export default class IpotekAkitTablosuAlacakForm extends Mixins(ObjectInputMixin) {
  @Prop() takipTipiId!: number;
  @Prop() errorAlacakKalemleri!: boolean;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop({default:()=>{}}) alacakDetay !: any;
  @Prop({default:()=>[]}) alacakKalemleri!:any
  @Prop({default: () => []}) ihtarlar!: any
  @Prop({default: () => []}) tasinmazlar!: any
  @Prop({default: () => []}) tasinirlar!: any

  isWizardComplete: boolean = false;
  TakipTipi = TakipTipi;
  paraBirimi = ParaBirimi;
  sozlesmeTuru = SozlesmeTuru;
  dovizTakipSekli = DovizTakipSekli;
  alacakKalemiAlani = AlacakKalemiAlani;
  alacakKalemiDetayData:any = {}
  tasinmazDetayData:any = {}
  tasinirDetayData:any = {}
  faizTurleri:any[] =  [];
  paraBirimleri:any[] =  []

  async getParaBirimleri(){
    let response = await this.$helper.requestWithCache("/api/v1/para-birimi-picker");
    this.paraBirimleri = response.data;
  }
  async getFaizTurleri(){
    let response = await this.$helper.requestWithCache("/api/v1/faiz-turu/?takibe_ozel_mi=false");
    this.faizTurleri = response.data;
  }

  getTakipOncesiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_oncesi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  getTakipSonrasiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_sonrasi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  headers = [
    {text: 'Alacak Kalemi Türü', value: 'alacak_kalemi_alani'},
    {text: 'Açıklama', value: 'aciklama'},
    {text: 'Faiz B. Tarihi', value: 'faiz_baslangic_tarihi'},
    {text: 'Takip Öncesi Faiz', value: 'takip_oncesi_faiz_turu'},
    {text: 'Takip Sonrası Faiz', value: 'takip_sonrasi_faiz_turu'},
    {text: 'Tutar', value: 'tutar'},
    {text: 'İşlemler', value: 'actions'},
  ]

  ihtarHeaders = [
    {text: 'Tarih', value: 'tarih'},
    {text: 'Tutar', value: 'tutar'},
    {text: 'Noter', value: 'noter'},
    {text: 'İşlemler', value: 'actions'},
  ]
  tasinirHeaders = [
    {text: 'Taşınır Türü', value: 'tur'},
    {text: 'Açıklama', value: 'aciklama'},
    {text: 'İşlemler', value: 'actions'},
  ]
  tasinmazHeaders = [
    {text: 'Ada', value: 'ada'},
    {text: 'Pafta', value: 'pafta'},
    {text: 'Parsel', value: 'parsel'},
    {text: 'İşlemler', value: 'actions'},
  ]

  get takipStore() {
    return this.$helper.getTakipStoreName(this.$route.path);
  }

  get takipBilgileri() {
    return this.$helper.getTakipBilgileri(this.$store.state, this.takipStore);
  }

  get defaultFormValues() {
    return this.$helper.getDefaultFormValues(this.takipBilgileri);
  }

  getParaBirimiSembol(paraBirimiId: number){
    const paraBirimi:any = this.paraBirimleri.find((p:any) => p.id === paraBirimiId);
    return paraBirimi ? paraBirimi.kisa_isim : '';
  }

  onAdd(){
    if (this.localValue.id){
      this.$emit('addAlacakKalemi')
    }
  }

  onAddIhtar(){
    if (this.localValue.id){
      this.$emit('addIhtar')
    }
  }
  onAddTasinmaz(){
    if (this.localValue.id){
      this.$emit('addTasinmaz')
    }
  }
  onAddTasinir(){
    if (this.localValue.id){
      this.$emit('addTasinir')
    }
  }
  addIhtar(item: any) {
    if (!this.localValue.id) {
      this.localValue.ihtarlar.push(item)
    }
  }

  updateIhtar(updatedItem: any, index: number) {
    if (!this.localValue.id) {
      this.$set(this.localValue.ihtarlar, index, updatedItem);
      this.input();
    }
  }
  addTasinmazlar(item: any) {
    if (!this.localValue.id) {
      this.localValue.tasinmazlar.push(item)
    }
  }
  addTasinirlar(item: any) {
    if (!this.localValue.id) {
      this.localValue.tasinirlar.push(item)
    }
  }
  addAsilAlacak(item:any){
    if(!this.localValue.id){
      this.localValue.asil_alacaklar.push(item)
    }else{
      this.onAdd()
    }
  }

  updateAsilAlacak(updatedItem: any, index: number) {
    if (this.localValue.id) {
      this.$emit('addAlacakKalemi');
    } else {
      this.$set(this.localValue.asil_alacaklar, index, updatedItem);
      this.input();
    }
  }

  tasinirDetay(id:any){
    this.$http.get('/api/v1/tasinir/' + id).then((response)=>{
      this.tasinirDetayData = response.data;
    })
  }

  tasinmazDetay(id:any){
    this.$http.get('/api/v1/tasinmaz/' + id).then((response)=>{
      this.tasinmazDetayData = response.data;
    })
  }

  alacakKalemiDetay(id:any){
    this.$http.get('/api/v1/alacak-kalemi/' + id).then((response)=>{
      this.alacakKalemiDetayData = response.data;
    })
  }
  deleteAsilAlacak(index: number ){
    if (this.localValue.id){
      this.$emit('delete')
    }else{
      this.localValue.asil_alacaklar.splice(index, 1);
    }
  }
  deleteIhtar(index: number) {
    if (this.localValue.id){
      this.$emit('deleteIhtar')
    }else{
      this.localValue.ihtarlar.splice(index, 1);
    }
  }
  deleteTasinir(index: number) {
    if (this.localValue.id){
      this.$emit('deleteTasinir')
    }else{
      this.localValue.tasinirlar.splice(index, 1);
    }
  }
  deleteTasinmaz(index: number) {
    if (this.localValue.id){
      this.$emit('deleteTasinmaz')
    }else{
      this.localValue.tasinmazlar.splice(index, 1);
    }
  }


  get aciklama() {
    if (this.localValue.yevmiye_no && this.localValue.belge_tarihi && this.localValue.tutar) {
      let belgeTarihi = this.$helper.tarihStr(this.localValue.belge_tarihi ?? "");
      return this.localValue.yevmiye_no + " yevmiye no’lu ve " + belgeTarihi +
          " tarihli ipotek belgesi ve akit tablosu";
    }
  }

  @Watch("aciklama")
  onAciklamaChange() {
    if(!this.localValue.id){
      this.localValue.aciklama = this.aciklama;
      this.input();
    }
  }

  @Watch('localValue.doviz_kur_tarihi')
  onDovizTakipSekliChange() {
    this.addParaBirimi();
    this.localValue.asil_alacaklar.forEach((asilAlacak: AlacakKalemiEntity) => {
      if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.vade) {
        asilAlacak.para_birimi_id = this.paraBirimi.TRY;
        asilAlacak.para_birimi = this.paraBirimleri.find((paraBirimi: any) => (paraBirimi.id == this.paraBirimi.TRY));
      } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {
        asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
        asilAlacak.para_birimi = this.localValue.para_birimi;
      }
    });
    this.input();
  }

  @Watch('localValue.para_birimi_id')
  onParaBirimiIdChange() {
    this.addParaBirimi();
  }

  @Watch('localValue')
  onLocalValueChange() {
    if (!this.localValue.takip_tarihli_kurlar) {
      this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY) {
      delete this.localValue.doviz_kur_tarihi;
      this.localValue.asil_alacaklar.forEach((asilAlacak: AlacakKalemiEntity) => {
        asilAlacak.para_birimi_id = this.paraBirimi.TRY;
        asilAlacak.para_birimi = this.paraBirimleri.find((paraBirimi: any) => (paraBirimi.id == this.paraBirimi.TRY));
      });
    } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {
      this.localValue.asil_alacaklar.forEach((asilAlacak: AlacakKalemiEntity) => {
        asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
        asilAlacak.para_birimi = this.localValue.para_birimi;
      });
    }
    this.addParaBirimi();
    this.input();
  }

  mounted() {
    this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    this.getFaizTurleri()
    this.getParaBirimleri()
    this.input();
  }

  load() {
    this.$emit('load');
  }
  loadAlacakKalemleri(){
    this.$emit('addAlacakKalemi')

  }
  addParaBirimi() {
    if (this.localValue.para_birimi_id != ParaBirimi.TRY &&
        !this.localValue.takip_tarihli_kurlar.find((kur:any) => kur.para_birimi_id == this.localValue.para_birimi_id)) {
      let kur = new TakipTarihliKurEntity();
      kur.para_birimi = this.localValue.para_birimi;
      kur.para_birimi_id = this.localValue.para_birimi_id;
      kur.tutar = null;
      this.localValue.takip_tarihli_kurlar.push(kur);
    }
  }
}
